import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-generic-list-dialog',
  templateUrl: './generic-list-dialog.component.html',
  styleUrls: ['../../../../../styles/global/_dialog-styles.scss']
})
export class GenericListDialogComponent {

  rows: string[];
  columnNumber = 1;
  tiles: string[] = [];

  constructor(public dialogRef: MatDialogRef<GenericListDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.rows = data.list;
    this.rows.forEach(row => {
      const columns = row.split(';');
      this.columnNumber = columns.length;
      columns.forEach(column => {
        this.tiles.push(column);
      });
    });
  }

  onSaveClick(): void {
    this.dialogRef.close();
  }

}
